import MagnifyingGlassIconPath from "@ingka/ssr-icon/paths/magnifying-glass";

export default MagnifyingGlassIconPath;
